import React, {useState} from 'react'
import styled from '@emotion/styled'
import { Formik, Field } from 'formik';
import { injectIntl,FormattedMessage } from "react-intl";
import fetch from "isomorphic-unfetch";
import Container from '../../common/Container';
import Button from "../../common/Button";
import sendEvent from '../../../helpers/sendAnalytics'



const PetSignupWrapper = styled.section`
  width: 50%;
  margin-left: auto;
  position: relative;
  padding: 50px 75px;

  img {
    position: absolute;
    right: 700px;
    bottom: 10px;
    max-width: 600px
  }

  h2 {
    ${tw`font-montserrat text-3xl font-normal m-0 mb-4`}
    max-width: 350px;
    color: #292B8F;
  }

  p {
    ${tw`font-raleway text-lg leading-normal m-0 mb-8`}
    max-width: 400px;
  }

  label {
    ${tw`font-raleway text-lg leading-normal m-0 mb-4 block`}
    color: #292B8F;
  }

  input[type=text],
  input[type=email] {
    border-radius: 25px;
    background: #E9E9F4;
    border: 2px solid #E9E9F4;
    transition: all 250ms ease-in;
    ${tw`text-gray-900 text-lg outline-none px-4 py-2 mt-2 block w-full`}

    &:focus,
    &:hover {
      border: 2px solid #464DA5;
      background: #D4D4E9;
    }
  }

  select {
    border-radius: 25px;
    border: 2px solid #E9E9F4;
    transition: all 250ms ease-in;
    appearance:none;
    background: #E9E9F4 url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNS45MDYgMTYuODk0Ij48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGRhdGEtbmFtZT0iQ2xpcCAyIiBkPSJNMCAwaDE2Ljg5NHYyNS45MDZIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyBkYXRhLW5hbWU9Ikdyb3VwIDMiIHRyYW5zZm9ybT0icm90YXRlKDkwIDEyLjk1MyAxMi45NTMpIiBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGRhdGEtbmFtZT0iRmlsbCAxIiBkPSJNNC4zMjcgMjUuNzUxbDEyLjQyLTEyLjQyNWEuNTQ1LjU0NSAwIDAwMC0uNzQ2TDQuMzI3LjE1NWEuNTI3LjUyNyAwIDAwLS43NDYgMEwuMTU1IDMuNTgzYS41MjcuNTI3IDAgMDAwIC43NDZsOC42MjEgOC42MjUtOC42MjEgOC42MjNhLjU0NS41NDUgMCAwMDAgLjc0N2wzLjQyNyAzLjQyN2EuNTI3LjUyNyAwIDAwLjc0NiAwIi8+PC9nPjwvc3ZnPg==");
    background-size: 18px;
    background-position: 96% 50%;
    background-repeat: no-repeat;
    ${tw`text-gray-900 text-lg outline-none px-4 py-2 mt-2 block w-full`}

    &:focus,
    &:hover {
      border: 2px solid #464DA5;
      background-color: #D4D4E9;
    }
  }

  fieldset {
    ${tw`flex border-0 p-0`}
    margin: 0 -10px;

    & > label {
      width: 50%;
      padding: 0 10px;
    }
  }

  input[type=checkbox] {
    margin-top: 10px;
    margin-left: 5px;
    -ms-transform: scale(2);
    -moz-transform: scale(2);
    -webkit-transform: scale(2);
    -o-transform: scale(2);
    transform: scale(2);
    border-color: green;
  }

  .accept {
    color: black;
    display: flex;
    align-items: flex-start;

    p {
      margin-left: 20px;
      margin-bottom: 0;
      line-height: 1.6;
      ${tw`text-sm`}

      a {
        color: #000;
        font-weight: bold;
        text-decoration: underline;
      }
    }
  }

  svg {
    display: none;
  }
  .pets-logo {
    display: none;
  }

  @media screen and (max-width: 54em) {
    width: 100%;
    padding: 20px;
    margin-top: 100px;
    img {
      display: none;
    }
    .pets-logo {
      display:block;
      position: relative;
      left: auto;
      right: auto;
      margin: 0 auto 50px;
      width: 200px;
    }

    h2 {
      ${tw`font-bold text-center`}
      max-width: 100%;
    }

    p {
      max-width: 100%;
      text-align: center;
    }

    fieldset {
      ${tw`block`}
      margin: 0;

      & > label {
        width: 100%;
        padding: 0;
      }
    }

    .accept {
      p {
        text-align: left;
      }
    }

    svg {
      display: block;
      width: 100px;
      margin: -70px auto 30px auto;
    }

    .pet-mobile-center {
      text-align: center;
      ${tw`text-xl`}
    }
  }
`

const PetButton = styled(Button)`
  background: #292B8F;
  border-color: #292B8F;
  padding: 15px 50px;

  &:focus,
  &:hover {
    background: #141677;
    border-color: #141677;
    text-decoration: underline;
  }

  @media screen and (max-width: 40em) {
    display: block;
    width: 100%;
  }
`

const PetContainer = styled(Container)`
  @media screen and (max-width: 54em) {
    padding: 0;
  }
`

const PetsSignUpBlock = ({locale,id}) => {
  // eslint-disable-next-line no-unused-vars
  const [submitted, setSubmitted] = useState(false)

  

  if (submitted) {
    return (
      <PetContainer>
        <PetSignupWrapper>
          <img className="pets-logo" src={locale === 'fr' ? "https://img.imageboss.me/royale-staging/width/240/format:webp/images/RHEPP_FR.png" : "https://img.imageboss.me/royale-staging/width/240/format:webp/images/RHEPP_EN.png"} alt="Logo HFEP" />
          <FormattedMessage id="petssign.text1">
            {(txt) => (
              <h2 dangerouslySetInnerHTML={{__html:txt}} />
            )}
          </FormattedMessage>

          <FormattedMessage id="petssign.text2">
            {(txt) => (
              <p dangerouslySetInnerHTML={{__html:txt}} />
            )}
          </FormattedMessage>
          <img src={locale === 'fr' ? "https://img.imageboss.me/royale-staging/width/720/format:webp/images/form-imageFR.jpg" : "https://img.imageboss.me/royale-staging/width/720/format:webp/images/form-imageEN.jpg"} alt="Royale Sign Up" />
          <FormattedMessage id="thank_you_subscribe_pets">
            {(txt) => (
              <h2 dangerouslySetInnerHTML={{__html:txt}} style={{'text-align':'center',width:'100%',margin: '200px 0',maxWidth:'100%'}} />
            )}
          </FormattedMessage>
        </PetSignupWrapper>
      </PetContainer>
    )
  }

  return (
    <PetContainer id={id}>
      <PetSignupWrapper>
        <img className="pets-logo" src={locale === 'fr' ? "https://img.imageboss.me/royale-staging/width/240/format:webp/images/RHEPP_FR.png" : "https://img.imageboss.me/royale-staging/width/240/format:webp/images/RHEPP_EN.png"} alt="Logo HFEP" />
        <FormattedMessage id="petssign.text1">
          {(txt) => (
            <h2 dangerouslySetInnerHTML={{__html:txt}} />
          )}
        </FormattedMessage>

        <FormattedMessage id="petssign.text2">
          {(txt) => (
            <p dangerouslySetInnerHTML={{__html:txt}} />
          )}
        </FormattedMessage>

        <img src={locale === 'fr' ? "https://img.imageboss.me/royale-staging/width/720/format:webp/images/form-imageFR.jpg" : "https://img.imageboss.me/royale-staging/width/720/format:webp/images/form-imageEN.jpg"} alt="Royale Sign Up" />
        <Formik
          initialValues={{
            firstname: '',
            lastname: '',
            email: '',
            accept: false
          }}
          validate={values => {
            const errors = {}

            if (!values.firstname) {
              errors.firstname = 'Required'
            }

            if (!values.lastname) {
              errors.lastname = 'Required'
            }

            if (!values.email) {
              errors.email = 'Required'
            }

            return errors
          }}
          onSubmit={(values) => {
            // ...

            const { firstname, lastname, email } = values
            const graphQlServer = `https://www.hawkemailsolutions.ca/api/create/email?firstname=${firstname}&lastname=${lastname}&email=${email}&brand=royale&language=${locale}`

            fetch(graphQlServer, {
              headers: {
                'content-type': 'application/json',
                'accept': 'application/json'
              },
              method: 'GET'
            })

            .then(res => res.json())
            .then(() => {
              sendEvent({
                ga: {
                  category: 'Email_Subscribe',
                  action: 'Click',
                  label: (locale === 'en') ? 'Pets_Email_Signup' : 'Pets_Email_Signup_FR'
                },
                gtag: {send_to: 'AW-951001886/dGoFCI-ql_0YEJ7GvMUD'}
              })

              sendEvent({
                gtag: {send_to: 'GTM-5SVFSFGH/formsubmit'}
              })

              setSubmitted(true)
            })
          }}
        >
          {({
              handleSubmit
            }) => (
              <form onSubmit={handleSubmit}>
                <fieldset>
                  <legend>Enter your name</legend>
                  <label>
                    <FormattedMessage id="petssign.text4" />
                    <Field type="text" name="firstname" required />
                  </label>

                  <label>
                    <FormattedMessage id="petssign.text5" />
                    <Field type="text" name="lastname" required />
                  </label>
                </fieldset>

                <label>
                  <FormattedMessage id="petssign.text6" />
                  <Field type="email" name="email" required />
                </label>

                <label className="accept">
                  <Field type="checkbox" name="accept" required />

                  <FormattedMessage id="petssign.text7">
                    {(txt) => (
                      <p dangerouslySetInnerHTML={{__html:txt}} />
                    )}
                  </FormattedMessage>
                </label>

                <PetButton>
                  <FormattedMessage id="petssign.text8" />
                </PetButton>
              </form>
          )}
        </Formik>
      </PetSignupWrapper>
    </PetContainer>
  )
}

export default injectIntl(PetsSignUpBlock)
